/**
 * Copyright (c) Flexi Apps.
 *
 * Functions to help doing expensive stuffs
 *
 */

// some config constants
import moment from "lib/moment";

import { GOOGLE_API_KEY } from "config/app";

// function to handle section list paging
export function mergeByTitle(data1, data2) {
  let arr = data1.concat(data2);
  let titles = new Map(arr.map(({ title }) => [title, new Map()]));
  arr.forEach(({ title, data }) => {
    let map = titles.get(title);
    data.forEach((o) => map.set(o._id, o));
  });

  const data = Array.from(titles.entries(), ([title, map]) => ({
    title,
    data: [...map.values()],
  }));

  const dataLength = data.reduce(
    (inc, current) => inc + current.data.length,
    0
  );

  return { data, dataLength };
}

// function to compute duration for a course to start
export function durationDiff(start_date) {
  const now = new Date();
  const diff = moment(start_date).diff(now);
  return moment.duration(diff, "ms").humanize(true);
}

export function cc_format(value) {
  var v = value.replace(/\s+/g, "").replace(/[^0-9]/gi, "");
  var matches = v.match(/\d{4,16}/g);
  var match = (matches && matches[0]) || "";
  var parts = [];

  for (var i = 0, len = match.length; i < len; i += 4) {
    parts.push(match.substring(i, i + 4));
  }

  if (parts.length) {
    return parts.join(" ");
  } else {
    return value;
  }
}

export const sortByCode = (elt1, elt2) => {
  const num1 = parseInt(elt1.code.replace("g", ""), 10);
  const num2 = parseInt(elt2.code.replace("g", ""), 10);
  if (num1 > num2) {
    return 1;
  }
  return -1;
};

export const downloadFile = (url, name) => {
  const filename = name || "devis.pdf";
  const link = document.createElement("a");

  if (link.download !== undefined) {
    link.setAttribute("href", url);
    link.setAttribute("download", filename);
    link.style.visibility = "hidden";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
};

export const getCookieProc = () => {
  try {
    const cookieValue = document.cookie.replace(
      /(?:(?:^|.*;\s*)procedureId\s*\=\s*([^;]*).*$)|^.*$/,
      "$1"
    );

    return cookieValue;
  } catch {
    return null;
  }
};

export const getCookieToken = () => {
  const token = document.cookie.replace(
    /(?:(?:^|.*;\s*)token\s*\=\s*([^;]*).*$)|^.*$/,
    "$1"
  );

  return token;
};

export const addressUrl = (address) =>
  `https://maps.googleapis.com/maps/api/geocode/json?address=${address}&language=fr&key=${GOOGLE_API_KEY}`;

export const geocodeAddress = (address) => {
  const promise = new Promise(async (resolve, reject) => {
    try {
      const res = await fetch(addressUrl(address));
      const data = await res.json();
      let { location } = data.results[0].geometry;

      resolve({ coordinates: [location.lng, location.lat] });
    } catch (e) {
      reject(e);
    }
  });

  return promise;
};
